module.exports = __webpack_public_path__ + "img/IMG_0744.d0aa1fdd.jpeg";